import React from "react";
import { Link } from "react-router-dom";
import { CreateCard } from "./CreateCard";
import { STRATEGIES } from "./mockData";
import { StrategyCard } from "./StrategyCard";

export function StrategiesSection() {
  return (
    <div className="mt-12">
      <div className="flex justify-between items-end mb-6">
        <h2 className="text-2xl font-bold text-slate-900">My strategies</h2>
        <Link
          to="/strategies"
          className="text-slate-500 text-sm hover:text-slate-900 flex items-center gap-1"
        >
          View all <span className="text-xs">▶</span>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 pb-20">
        <CreateCard />
        {STRATEGIES.map((strategy) => (
          <StrategyCard key={strategy.id} data={strategy} />
        ))}
      </div>
    </div>
  );
}
